<script>
import { ungerboeckEnvironment } from "@/environment";

export default {
  name: "EnvironmentBanner",
  data() {
    return {
      environment: ungerboeckEnvironment,
      bannerClasses: `banner banner-${ungerboeckEnvironment.toLowerCase()}`,
    };
  },
};
</script>

<template>
  <div :class="bannerClasses">
    <p class="mb-0">{{ environment }}</p>
  </div>
</template>
